<template>
<div></div>
</template>

<script>
export default {
  name: 'LKdownLoad',
  created () {
    var u = navigator.userAgent
    if (u.indexOf('iPhone') > -1) {
      window.location.href = 'https://apps.apple.com/cn/app/%E9%A2%86%E5%85%8B%E8%A1%8C%E8%BD%A6%E8%AE%B0%E5%BD%95%E4%BB%AA/id1582932738'
      if (u.indexOf('MicroMessenger') > -1) {
        document.body.setAttribute('class', 'trendwin')
      }
    } else {
      window.location.href = '/download/LynkCo_1.1.0.apk'
    }
  }
}
</script>

<style scoped>

</style>
